<template>
  <div>
    <div class="container-fluid">
      <div class="llp-container-section heightcontainer">
        <top-header id="height2"></top-header>
        <main-menu id="height3"></main-menu>
        <!-- Start the code for this screen here -->
        <div
          id="reporting"
          class="container-fluid overflow-auto pb-4 menu-margin-top"
          style="padding-left:0px;padding-right:0px"
        >
          <div>
            <nav class="navbar navbar-expand-lg bg-info text-white">
              <span>
                <b>Customer Fraud History</b>
              </span>
            </nav>
          </div>
          <center>
            <span :style="msgcolor">
              <b>{{ message }}</b>
            </span>
          </center>
          <br />

          <div
            class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2"
          >
            <div
              class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center"
            >
              <label class="col-form-label col-form-label-sm required">
                <b>Customers</b>
              </label>
            </div>
            <div
              class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
            >
              <multiselect
                style="width:100%"
                v-model="selectedCustomerId"
                :options="customersList"
                placeholder="Select Customer"
                :value="customersList.customerId"
                :custom-label="displayFullName"
                selected="selected"
                id="customersdd"
                @input="getCustomerFraudHistory()"
              ></multiselect>
            </div>
            <div
              class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
            >
              <input type="checkbox" v-model="ischecked" class="mr-2" />Show
              Fraud Details
            </div>
          </div>
          <br />
          <br />

          <div class="row p-2 justify-content-center">
            <div class="col">
              <div
                class="table-responsive table-responsive-sm mb-5"
                style="height:187px;overflow:auto;"
              >
                <v-table
                  id="myappsTable"
                  :data="customerFraudHistory"
                  :currentPage.sync="currentPage"
                  :pageSize="5"
                  @totalPagesChanged="totalPages = $event"
                  class="table table-sm table-bordered table-striped"
                >
                  <thead class="table-month-header-blue wrap-text" slot="head">
                    <v-th sortKey="firstName">First Name</v-th>
                    <v-th sortKey="middleName">Middle Name</v-th>
                    <v-th sortKey="lastName">Last Name</v-th>
                    <v-th sortKey="businessName">Business Name</v-th>
                    <v-th sortKey="fraudReason">Customer Fraud Reason</v-th>
                    <v-th sortKey="customerFraudFlag"
                      >Customer Fraud Indicator</v-th
                    >
                    <v-th sortKey="primaryPhoneNumber"
                      >Primary Phone Number</v-th
                    >
                    <v-th sortKey="primaryPhoneFraudFlag"
                      >Phone Fraud Flag</v-th
                    >
                    <v-th sortKey="status">Customer Status</v-th>
                    <v-th sortKey="updatedD">Updated date</v-th>
                    <v-th sortKey="updatedUserId">Updated By</v-th>
                  </thead>
                  <tbody slot="body" slot-scope="{ displayData }">
                    <tr
                      v-for="(customerfraud, index) in displayData"
                      :key="index"
                      class="table-month-row"
                    >
                      <td class="table-month-td">
                        {{ customerfraud.firstName }}
                      </td>
                      <td class="table-month-td">
                        {{ customerfraud.middleName }}
                      </td>
                      <td class="table-month-td">
                        {{ customerfraud.lastName }}
                      </td>
                      <td class="table-month-td">
                        {{ customerfraud.businessName }}
                      </td>
                      <td class="table-month-td">
                        {{ customerfraud.fraudReason }}
                      </td>
                      <td class="table-month-td">
                        {{ customerfraud.customerFraudFlag }}
                      </td>
                      <td class="table-month-td">
                        {{ customerfraud.primaryPhoneNumber }}
                      </td>
                      <td class="table-month-td">
                        {{ customerfraud.primaryPhoneFraudFlag }}
                      </td>
                      <td class="table-month-td">{{ customerfraud.status }}</td>
                      <td class="table-month-td">
                        {{ customerfraud.updatedD }}
                      </td>
                      <td class="table-month-td">
                        {{ customerfraud.updatedUserId }}
                      </td>
                    </tr>
                  </tbody>
                </v-table>
              </div>
            </div>
          </div>

          <br />
        </div>
        <bottom-footer></bottom-footer>
      </div>
    </div>
  </div>
</template>
<script>
import TopHeader from '@/components/TopHeader.vue'
import BottomFooter from '@/components/BottomFooter.vue'
import MainMenu from '@/components/Menu.vue'
import httpcommon from '../js/http-common.js'
import httpcommonzero from '../js/http-common-zero.js'
import httpcustomer from '../js/http-customer.js'
import multiselectcss from '@/css/vue-multiselect.min.css'
import { bus } from '../main'
import { debug } from 'util'
export default {
  components: { MainMenu, TopHeader, BottomFooter, multiselectcss },
  data () {
    return {
      message: '',
      selectedCustomerId: '',
      customer: this.customerObject(),
      customerFraudHistory: [],
      customersList: [],
      filters: [],
      ischecked: true,
      msgcolor: {
        color: 'black'
      },
      currentPage: 1,
      totalPages: 0,
      colheaders: [
        { header: 'First Name' },
        { header: 'Middle Name' },
        { header: 'Last Name' },
        { header: 'Business Name' },
        { header: 'Customer Fraud Reason' },
        { header: 'Customer Fraud Indicatior' },
        { header: 'Primary Phone Number' },
        { header: 'Phone Fraud Flag' },
        { header: 'Customer Status' },
        { header: 'Updated Date' },
        { header: 'Updated By' }
      ]
    }
  },
  methods: {
    customerObject () {
      return {
        firstName: '',
        middleName: '',
        lastName: '',
        businessName: ''
      }
    },
    myFunction () {
      var elmnt = document.getElementById('height2')
      var elmnt1 = document.getElementById('height3')
      var txt = elmnt.offsetHeight
      var width = elmnt.offsetWidth
      var txt1 = elmnt1.offsetHeight
      var ht = txt + txt1
      $('#reporting').css('margin-top', txt + txt1 + 3)
    },
    menuheight () {
      var elmnt = document.getElementById('height2')
      var txt = elmnt.offsetHeight
      $('#height3').css('margin-top', txt)
    },
    displayFullName (option) {
      if (option.customerType == 'P') {
        return `${option.firstName} ${
          option.middleName != null && option.middleName.length != 0
            ? ',' + option.middleName
            : ''
        } ,${
          option.lastName != null && option.lastName.length != 0
            ? option.lastName
            : ''
        }`
      } else if (option.customerType == 'B') {
        return `${option.businessName}`
      }
    },
    fetchData () {
      this.retrieveCustomerList()
    },
    retrieveCustomerList () {
      httpcustomer
        .get('/customer/getcustomerNames')
        .then(response => {
          this.customersList = response.data
        })
        .catch(e => {
          console.log(e)
          this.errors.push(e)
        })
    },
    getCustomerFraudHistory () {
      httpcustomer
        .get(
          '/customer/getcustomerFraudAudit/?customerId=' +
            this.selectedCustomerId.customerId
        )
        .then(response => {
          this.customerFraudHistory = response.data
        })
        .catch(e => {
          console.log(e)
          this.errors.push(e)
        })
    }
  },
  computed: {
    filterfraud: function () {
      if (this.ischecked == true) {
        return this.customerFraudHistory.filter(customer => {
          return (
            customer.customerFraudFlag == 'Y' ||
            customer.primaryPhoneFraudFlag == 'Y'
          )
        })
      } else return this.customerFraudHistory
    }
  },
  mounted () {
    this.fetchData()
    this.myFunction()
    this.menuheight()
  },
  created () {
    window.addEventListener('resize', this.myFunction)
    window.addEventListener('resize', this.menuheight)
  }
}
</script>
<style scoped>
.floatleft {
  float: left;
}
.wrap-text {
  white-space: nowrap;
}
</style>
